export default "__VITE_ASSET__DdPeFCUc__"